import {
  Component,
  OnInit,
  Input,
  PLATFORM_ID,
  Inject,
  ChangeDetectionStrategy,
} from "@angular/core";
import { DataService } from "../../../@core/services/data.service";
import { Subscription } from "rxjs";
import {
  FeaturesSliderInterface,
  FeatureSliderModel,
} from "../../../@core/models/site-data.model";
import * as Sentry from "@sentry/browser";
import { AnalyticsService } from "../../../@core/services/analytics.service";
import { isPlatformBrowser } from "@angular/common";


@Component({
  selector: "app-features-slider",
  templateUrl: "./features-slider.component.html",
  styleUrls: ["./features-slider.component.scss"],
  changeDetection: ChangeDetectionStrategy.Default
})
export class MaterialFeaturesSliderComponent implements OnInit {
  @Input() featureImages: FeatureSliderModel[];
  @Input() grayedOut: boolean = true;
  title: string;
  titleSize: string;
  backgroundColor: string;
  titleColor: string;
  activatePadding: boolean = false;
  subTitleColor: string;
  subTitle: string;
  subscription: Subscription;
  data: FeaturesSliderInterface;
  position: number = 0;
  moduleInfo: string;
  buttonText: string;
  buttonLink: string;
  indexImageSlider: number = -1;
  timeOut;
  allElementAnimation: string;
  textAnimation: string;
  imageAnimation: string;
  loading: boolean = true;

  constructor(
    private dataService: DataService,
    @Inject(PLATFORM_ID) public platformId,
    private analyticsService: AnalyticsService
  ) { }

  ngOnInit() {
    Sentry.configureScope(function (scope) {
      scope.setTag("component", "FeaturesSliderComponent");
    });
    if (this.data.animation) {
      this.allElementAnimation = this.data.animation.allElement != '' ? this.data.animation.allElement : undefined;
      this.textAnimation = this.data.animation.text != '' ? this.data.animation.text : undefined;
      this.imageAnimation = this.data.animation.image != '' ? this.data.animation.image : undefined;

    }
    this.loading = false;
    this.moduleInfo = JSON.stringify({ position: this.position, new: false });
    this.featureImages = this.data.features;
    this.title = this.data.title;
    this.subTitle = this.data.subTitle;
    this.titleColor = this.data.titleColor;
    this.subTitleColor = this.data.subTitleColor;
    this.backgroundColor = this.data.backgroundColor
      ? this.data.backgroundColor
      : "";
    this.titleColor = this.data.titleColor ? this.data.titleColor : this.dataService.getDefaultColor(this.backgroundColor);
    this.titleSize = this.data.titleSize ? this.data.titleSize : "";
    this.buttonText = this.data.buttonText ? this.data.buttonText : "";
    this.buttonLink = this.data.buttonLink ? this.data.buttonLink : "";
    this.sliderBackgroundImage();
  }
  sliderBackgroundImage() {
    this.indexImageSlider++;
    if (this.featureImages.length <= this.indexImageSlider) {
      this.indexImageSlider = 0;
    }
    if (isPlatformBrowser(this.platformId)) {
      this.timeOut = setTimeout(() => {
        this.sliderBackgroundImage();
      }, 5000);
    }
  }
  setImageSlider(index: number) {
    this.indexImageSlider = index;
    if (isPlatformBrowser(this.platformId)) {
      clearTimeout(this.timeOut);
      this.timeOut = setTimeout(() => {
        this.sliderBackgroundImage();
      }, 5000);
    }
  }
  openLink(link: string) {
    if (link) {
      const currentSite = this.dataService.site$.getValue();
      if (currentSite) {
        this.analyticsService.trackConversion(currentSite, "click");
      }
      window.open(link, "_blank");
    }
  }
}
